import queryString from 'query-string';

import { api, type IFetchApiProps } from './api';

import type {
  IMessageVM,
  TListResponse,
  IConversationVM,
  ICreatedConvoVM,
} from '~/types';

export const QK_FETCH_CONVERSATIONS = 'qk_fetchConversations';
export const QK_FETCH_CONVERSATION_MESSAGES = 'qk_fetchConversationMessages';

interface IGetConversationRequest extends IFetchApiProps {
  page: number;
}

function getConversations({
  signal,
  page = 1,
}: IGetConversationRequest): Promise<TListResponse<IConversationVM>> {
  return api.get(
    queryString.stringifyUrl(
      {
        url: `/chat/conversations`,
        query: {
          'page[number]': page,
        },
      },
      {
        arrayFormat: 'bracket',
      },
    ),
    {
      signal,
    },
  );
}

interface IGetConversationMessagesRequest extends IFetchApiProps {
  page: number;
  conversationId: string;
}

function getConversationMessages({
  signal,
  page = 1,
  conversationId,
}: IGetConversationMessagesRequest): Promise<TListResponse<IMessageVM>> {
  return api.get(
    queryString.stringifyUrl(
      {
        url: `/chat/conversations/${conversationId}/messages`,
        query: {
          'page[number]': page,
        },
      },
      {
        arrayFormat: 'bracket',
      },
    ),
    {
      signal,
    },
  );
}

function createChatConversation(userId: string): Promise<ICreatedConvoVM> {
  return api.post(`/chat/conversations/create_private?user_id=${userId}`);
}

export const chatApi = {
  getConversations,
  getConversationMessages,
  createChatConversation,
} as const;
